import { render, staticRenderFns } from "./ArticleAdmin.vue?vue&type=template&id=9921b4f2&scoped=true&"
import script from "./ArticleAdmin.vue?vue&type=script&lang=js&"
export * from "./ArticleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ArticleAdmin.vue?vue&type=style&index=0&id=9921b4f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9921b4f2",
  null
  
)

export default component.exports